import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { getDocs, query, where, collection, orderBy, limit } from "firebase/firestore";
import { db } from "../firebase";
import Cookies from 'js-cookie';
import { Helmet } from "react-helmet";

import { Toast } from '../components_root/ToastContext';
export const seo = {
    title: "My Account | Manage Your Aooz Profile & Settings",
    description: "Access and manage your Aooz account profile, personal details, subscriptions, saved tools, and preferences. Securely update your information and control your productivity tools in one place.",
    keywords: "Aooz account, Aooz profile, manage account, user dashboard, Aooz login, profile settings, account management, subscription settings, productivity dashboard",
    url: "https://aooz.in/account",
    image: "https://aooz.in/assets/logo.png"
};
export default function Account_profile() {
    const navigate = useNavigate();
    const [user, setUser] = useState(null);
    const [guid, setguid] = useState('');

    const [isLoading, setIsLoading] = useState(false);
    const [accountstatus, setAccountstatus] = useState(false);
    const popupRef = useRef(null);
    const [islogin, setIslogin] = useState(false);
    const [accountdata, setAccountdata] = useState([]);
    //
    const [accountname, setaccountname] = useState("");

    useEffect(() => {
        const existingsessiontoken = Cookies.get("sessiontoken");
        if (existingsessiontoken !== null && existingsessiontoken !== undefined) {
            setguid(Cookies.get("guid"));
        }
    }, [navigate]);


    useEffect(() => {
        const checkIntegration = async () => {
            try {
                const checkQuery = query(
                    collection(db, "accounts"),
                    where("guid", "==", guid)
                );

                const checkSnap = await getDocs(checkQuery);

                if (checkSnap.empty) {

                    navigate('/login');
                    return;
                }

                const dataList = checkSnap.docs.map((doc) => ({
                    uid: doc.id,
                    ...doc.data(),
                }));

                setAccountdata(dataList[0]); // first document
                setaccountname(dataList[0].name || "");
                if (dataList.length > 0) {
                    setAccountstatus(dataList[0].status);
                }

            } catch (err) {
                console.error("Error checking API integration:", err);
            }
        };

        if (guid) {
            checkIntegration();
        }
    }, [guid, navigate]);
    return (
        <div>

            <Helmet>
                <title>{seo.title}</title>
                <meta name="description" content={seo.description} />
                <meta name="keywords" content={seo.keywords} />
                <meta property="og:title" content={seo.title} />
                <meta property="og:description" content={seo.description} />
                <meta property="og:image" content={seo.image} />
                <meta property="og:url" content={seo.url} />
            </Helmet>

            <div className="container_roots">
                <div className="container_size_info">
                    <h2 className="text-xl font-bold mb-4">Account Settings</h2>
                    <div className='post-container'>
                        <div className="post_div">
                            <div className='b-1 rounded p-11'>
                                {accountname.length < 2 &&(
                                    <div className='text-h3 m-l text-off fcap'>Account name</div>
                                )}

                                <input className='text-h2 fcap bold border-none' value={accountname} onChange={(e) => setaccountname(e.target.value)} placeholder="Account name"></input>

                            </div>
                        </div>
                        <div className="post_updates">post_updates</div>
                    </div>

                </div>

            </div>



        </div>
    );
}
